module.exports = __webpack_public_path__ + "static/expires-c9d9b5ddcd644ec4fd579e7bc5546918.svg";